import { FieldStateV3 } from '../states/form/FormStateV3';
import { BaseSubmissionFieldDefinition, EmptyParameters, StringFieldParameters } from './lesson_homeworks';

export type LessonHomeworkId = number;

/**
 * 課題提出で受け付ける提出のタイプ
 */
export enum SubmissionFieldType {
    /**
     * ファイルアップロード
     */
    FILE = 'file',
    /**
     * Googleの共有リンク
     */
    GOOGLE_URL = 'google_url',
    /**
     * 1行テキスト
     */
    SINGLE_LINE_TEXT = 'single_line_text',
    /**
     * 複数行テキスト
     */
    MULTI_LINE_TEXT = 'multi_line_text',
}

/**
 * 提出できるフィールドの入稿時に仕様する型
 */
export type BaseSubmissionFieldDefinition<T extends SubmissionFieldType, P> = {
    uid: string;
    type: T;
    label: string;
    required: boolean;
    parameters: P;
};

export type EmptyParameters = {};
export type StringFieldParameters = { placeholder: string };

export type SubmissionFieldDefinition =
    | BaseSubmissionFieldDefinition<SubmissionFieldType.FILE, EmptyParameters>
    | BaseSubmissionFieldDefinition<SubmissionFieldType.GOOGLE_URL, StringFieldParameters>
    | BaseSubmissionFieldDefinition<SubmissionFieldType.SINGLE_LINE_TEXT, StringFieldParameters>
    | BaseSubmissionFieldDefinition<SubmissionFieldType.MULTI_LINE_TEXT, StringFieldParameters>;
/**
 * 実際に提出された値の型
 */
export type SubmitFieldState = {
    definition: SubmissionFieldDefinition;
    state: FieldStateV3<any>;
};
